module.exports = __webpack_public_path__ + "img/e_1_8_r.80fa0662.png";